import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { ReactFlowProvider } from 'reactflow';
export const GraphContext = React.createContext({
    viewPortCache: new Map()
});
export function GraphProvider({ children }) {
    const viewPortCache = useMemo(() => new Map(), []);
    const ctx = useMemo(() => ({ viewPortCache }), [viewPortCache]);
    return (_jsx(ReactFlowProvider, { children: _jsx(GraphContext.Provider, { value: ctx, children: children }) }));
}
export function useGraphContext() {
    return React.useContext(GraphContext);
}
